import { Actions, createEffect } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, delay, filter, map, mergeMap } from 'rxjs/operators';
import { AddAlert, RemoveAlert } from './alerts.action';

@Injectable()
export class AlertEffects {
    constructor(private actions$: Actions) {}

    autoDismiss$ = createEffect(() =>
        this.actions$.pipe(
            filter((action: Action) => action instanceof AddAlert),
            mergeMap((action: AddAlert) =>
                action.payload.timer > 0
                    ? of(action).pipe(
                          delay(action.payload.timer),
                          map(() => new RemoveAlert(action.payload.id)),
                          catchError(() => EMPTY)
                      )
                    : EMPTY
            )
        )
    );
}
